import { DatePicker } from "@mui/x-date-pickers";
import { Controller } from "react-hook-form";

import { FieldComponent } from "../types";

const DatePickerComponent: FieldComponent<never> = ({ field, methods }) => {
  const {
    formState: { errors },
  } = methods;
  const error = errors[field.name];

  return (
    <Controller
      name={field.name}
      control={methods.control}
      defaultValue={field.defaultValue || null}
      render={({ field: controllerField }) => {
        let value: Date | null = null;
        if (
          typeof controllerField.value === "string" &&
          controllerField.value
        ) {
          const parsed = new Date(controllerField.value);
          value = isNaN(parsed.getTime()) ? null : parsed;
        } else if (controllerField.value instanceof Date) {
          value = controllerField.value;
        } else {
          value = null;
        }
        const handleChange = (date: unknown): void => {
          controllerField.onChange(date);
          if (field.type === "date" && "onChange" in field && field.onChange) {
            const syntheticEvent = {
              target: {
                name: field.name,
                value: date,
              },
            } as React.ChangeEvent<HTMLInputElement>;
            field.onChange(syntheticEvent);
          }
        };
        return (
          <DatePicker
            {...controllerField}
            value={value}
            onChange={handleChange}
            label={field.label}
            disabled={field.disabled}
            slotProps={{
              textField: {
                fullWidth: true,
                error: Boolean(error),
                helperText: error?.message as string,
                required: field?.required,
              },
            }}
          />
        );
      }}
    />
  );
};

export default DatePickerComponent;
